<template>
  <div>
    <v-dialog v-model="dialog" :persistent="persistant" max-width="800px">
      <v-card>
        <!-- <v-card-title
          class="headline primary--text"
          primary-title
        >
          Getting Started Checklist
        </v-card-title> -->
        <v-card-text class="no-padding">
          <v-toolbar color="primary" flat dark>
            <v-toolbar-title v-if="userProfile.phase === 1">Fresh Start Checklist</v-toolbar-title>
            <v-toolbar-title v-else>Phase {{userProfile.phase}}: Checklist</v-toolbar-title>
          </v-toolbar>
           <v-list
          two-line
        >
          <p v-if="userProfile.phase > 1" style="padding: 0 16px;">
            Before you continue on your journey plesse complete the following.
          </p>
          <v-list-tile v-if="userProfile.phase === 1" @click="goTo('Add Weight Goals')">
            <v-list-tile-action>
              <v-checkbox v-model="goals"></v-checkbox>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Weight Goals</v-list-tile-title>
              <v-list-tile-sub-title></v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>input</v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="goTo('Add Measurements')">
            <v-list-tile-action>
              <v-checkbox v-model="measurements"></v-checkbox>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Measurements</v-list-tile-title>
              <v-list-tile-sub-title v-if="userProfile.phase === 1">Please provide your starting measurements.</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>input</v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="goTo('Add Progress Photos')">
            <v-list-tile-action>
              <v-checkbox v-model="startingPhotos"></v-checkbox>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title><span v-if="userProfile.phase === 1">Starting</span><span v-if="userProfile.phase > 1">Progress</span> photos</v-list-tile-title>
              <v-list-tile-sub-title></v-list-tile-sub-title>
            </v-list-tile-content>

             <v-list-tile-action>
              <v-icon>input</v-icon>
            </v-list-tile-action>
          </v-list-tile>

        </v-list>
        </v-card-text>
        <!-- <v-card-actions class="no-padding">
          <v-btn @click.native="submitRating" :loading="loadingSave" color="primary" block depressed dark>submit</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </div>

</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['user', 'userProfile', 'dialog', 'measurements', 'startingPhotos', 'goals', 'persistant'],
  mounted () {
  },
  methods: {
    goTo: function (title) {
      this.$router.push({name: title})
    }
  },
  computed: {
  }
}
</script>
<style scoped>
  /* .alert {
    position: absolute;
    bottom: -12px;
    left: 0;
    right: 0;
    margin: auto;
  } */
</style>



// WEBPACK FOOTER //
// src/components/partial/checklist.vue